// extracted by mini-css-extract-plugin
module.exports = {"headingWrapper":"TitleText_headingWrapper__cO04b","heading":"TitleText_heading__uXYgd","subHeading":"TitleText_subHeading__QeSc3"};